import { render, staticRenderFns } from "./LinkButton.vue?vue&type=template&id=3192b3fa&scoped=true&lang=pug"
import script from "./LinkButton.vue?vue&type=script&lang=js"
export * from "./LinkButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3192b3fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3192b3fa')) {
      api.createRecord('3192b3fa', component.options)
    } else {
      api.reload('3192b3fa', component.options)
    }
    module.hot.accept("./LinkButton.vue?vue&type=template&id=3192b3fa&scoped=true&lang=pug", function () {
      api.rerender('3192b3fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/buttons/LinkButton.vue"
export default component.exports